<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <div class="exhibitor-backoffice__content">
      <h2>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.TITLE' | translate }}</h2>

      <div class="alert alert-{{alertType}} alert-dismissible" role="alert" *ngIf="alertMessage">
        {{ alertMessage | translate }}
      </div>

      <div class="section-container">
        <form name="form" class="form" #form="ngForm">
          <div class="row align-items-end">
            <div class="col-12 col-md-4">
              <div class="form-group mb-0">
                <label for="file" class="form-label mb-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.CHOOSE_FILE' | translate }}</label>
                <input type="file" id="file" name="file" (change)="onFileChange($event)" class="form-control" accept=".csv,.xlsx">
                <div style="min-height: 20px;">
                  <small class="form-text text-muted" *ngIf="selectedFile && !isValidFile" style="color: red !important;">
                    {{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.CHOOSE_FILE_TYPES' | translate }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="d-flex justify-content-end align-items-center" style="margin-bottom: 20px;">
                <button type="button" class="btn btn--submit" (click)="uploadBtn()" [disabled]="!isValidFile || loader.count > 0" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
                  {{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.IMPORT' | translate }}
                </button>
                <button type="button" class="btn btn-secondary ms-2" (click)="downloadTemplate()" [disabled]="loader.count > 0">
                  <i class="fas fa-download me-1"></i> {{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.DOWNLOAD_TEMPLATE' | translate }}
                </button>
                <button type="button" class="btn btn--light ms-2" (click)="cancel()" [disabled]="loader.count > 0">
                  {{ 'COMMON.CANCEL' | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<app-loader *ngIf="loader.count > 0"></app-loader>
